import React from "react";
import { Route, Routes } from "react-router-dom";
import LoginPageComponent from "../../pages/accounts/LoginPageComponent";
import RegisterPageComponent from "../../pages/accounts/RegisterPageComponent";
import AddCategoryPageComponent from "../../pages/items/categories/AddCategoryPageComponent";
import CategoriesListPageComponent from "../../pages/items/categories/CategoriesListPageComponent";
import EditCategoryPageComponent from "../../pages/items/categories/EditCategoryPageComponent";
import AddAttributePageComponent from "../../pages/items/attributes/AddAttributePageComponent";
import GetAttributesPageComponent from "../../pages/items/attributes/GetAttributesPageComponent";
import EditAttributePageComponent from "../../pages/items/attributes/EditAttributePageComponent";
import AttributeValuesPageComponent from "../../pages/items/attributes/attributesValues/AttributeValuesPageComponent";
// prices
import AddPriceListPageComponent from "../../pages/items/prices/AddPriceListPageComponent";
import GetPriceListsPageComponent from "../../pages/items/prices/GetPriceListsPageComponent";
import EditPriceListPageComponent from "../../pages/items/prices/EditPriceListPageComponent";
// items
import AddProductPageComponent from "../../pages/items/controls/AddProductPageComponent";
import EditProductPageComponent from "../../pages/items/controls/EditProductPageComponent";
import ManageProductPricePageComponent from "../../pages/items/controls/ManageProductPricePageComponent";
import ManageProductImagesPageComponent from "../../pages/items/controls/ManageProductImagesPageComponent";
import ItemListPageComponent from "../../pages/items/ItemListPageComponent";
import HomePageComponent from "../../pages/home/HomePageComponent";
import DialogManagerComponent from "../../components/dialogs/DialogManagerComponent";
import AdminDashboardPageComponent from "../../pages/dashboard/admin/AdminDashboardPageComponent.jsx";
import ShoppingCartPageComponent from "../../pages/shoppingCart/ShoppingCartPageComponent.jsx";
import AdminRoute from "../../middlewares/routing/AdminRoute.middleware.js";
import ThankYouPageComponent from "../../pages/orders/ThankYouPageComponent.jsx";
import BusinessRoute from "../../middlewares/routing/BusinessRoute.middleware.js";
import BusinessDashboardPageComponent from "../../pages/dashboard/BusinessDashboardPageComponent.jsx";
import OrdersHistoryPageComponent from "../../pages/dashboard/orders/OrdersHistoryPageComponent.jsx";
import AdminManageItemPageComponent from "../../pages/dashboard/admin/AdminManageItemPageComponent.jsx";
import AdminCatalogManagementPageComponent from "../../pages/dashboard/admin/AdminCatalogManagementPageComponent.jsx";
import BusinessOrdersTableComponent from "../../components/orders/BusinessOrdersTableComponent.jsx";
import AgentRoute from "../../middlewares/routing/AgentRoute.middleware.js";
import AgentDashboardPageComponent from "../../pages/dashboard/agent/AgentDashboardPageComponent.jsx";

const AppRoutes = () => {
  return (
    <Routes>
      {/* <Route path="/login" element={<LoginPageComponent />} /> */}
      <Route path="/register" element={<RegisterPageComponent />} />

      <Route path="/add-category" element={<AddCategoryPageComponent />} />
      <Route path="/categories" element={<CategoriesListPageComponent />} />
      <Route path="/categories/edit/:categoryId" element={<EditCategoryPageComponent />} />

      <Route path="/add-attribute" element={<AddAttributePageComponent />} />
      <Route path="/attributes" element={<GetAttributesPageComponent />} />
      <Route path="/attributes/edit/:id" element={<EditAttributePageComponent />} />
      <Route path="/attributes/:attributeId/values" element={<AttributeValuesPageComponent />} />

      <Route path="/add-priceList" element={<AddPriceListPageComponent />} />
      <Route path="/priceLists" element={<GetPriceListsPageComponent />} />
      <Route path="/priceLists/edit/:priceListId" element={<EditPriceListPageComponent />} />

      {/* <Route path="/add-product" element={<AddProductPageComponent />} /> */}
      {/* <Route path="/items" element={<getItemsPageComponent />} />
      <Route path="/items/edit/:productId" element={<EditProductPageComponent />} />
      <Route path="/items/:productId/prices" element={<ManageProductPricePageComponent />} />
      <Route path="/items/:productId/images" element={<ManageProductImagesPageComponent />} /> */}

      <Route path="/categories/:categoryId" element={<ItemListPageComponent />} />
      <Route path="/categories/:categoryId/itemGroup/:itemGroupId" element={<ItemListPageComponent />} />
      <Route path="/search" element={<ItemListPageComponent />} />
      <Route path="/items" element={<ItemListPageComponent />} />

      <Route
        path="admin/dashboard/:userId"
        element={
          <AdminRoute>
            <AdminDashboardPageComponent />
          </AdminRoute>
        }
      />
      <Route
        path="admin/dashboard/:userId/items"
        element={
          <AdminRoute>
            <AdminManageItemPageComponent />
          </AdminRoute>
        }
      />
      <Route
        path="admin/dashboard/:userId/catalog"
        element={
          <AdminRoute>
            <AdminCatalogManagementPageComponent />
          </AdminRoute>
        }
      />
      <Route
        path="admin/dashboard/:userId/orders"
        element={
          <AdminRoute>
            <BusinessOrdersTableComponent />
          </AdminRoute>
        }
      />
      <Route
        path="agent/dashboard/:userId"
        element={
          <AgentRoute>
            <AgentDashboardPageComponent />
          </AgentRoute>
        }
      />
      <Route
        path="agent/dashboard/:userId/orders"
        element={
          <AgentRoute>
            <BusinessOrdersTableComponent />
          </AgentRoute>
        }
      />
      <Route
        path="business/dashboard/:userId"
        element={
          <BusinessRoute>
            <BusinessDashboardPageComponent />
          </BusinessRoute>
        }
      />
      <Route
        path="business/dashboard/:userId/orders"
        element={
          <BusinessRoute>
            <OrdersHistoryPageComponent />
          </BusinessRoute>
        }
      />

      <Route path="/thank-you" element={<ThankYouPageComponent />} />
      <Route path="/shoppingCart" element={<ShoppingCartPageComponent />} />
      <Route path="/" element={<HomePageComponent />} />
    </Routes>
  );
};

export default AppRoutes;
